import React from 'react';
import { useLanguage } from '../context/LanguageContext';
export function Privacy() {
  const {
    language
  } = useLanguage();
  const isIS = language === 'is';
  return <div className="min-h-screen bg-white" data-id="element-1144">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24" data-id="element-1145">
        <h1 className="font-heading text-4xl font-bold text-charcoal mb-2" data-id="element-1146">
          {isIS ? 'Persónuverndarstefna' : 'Privacy Policy'}
        </h1>
        <p className="text-gray-400 text-sm mb-12" data-id="element-1147">
          {isIS ? 'Uppfært: janúar 2025' : 'Updated: January 2025'}
        </p>

        <div className="prose prose-gray max-w-none space-y-8 text-gray-600 leading-relaxed" data-id="element-1148">

          {isIS ? <>
              <section data-id="element-1149">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1150">Hver er ábyrgðaraðilinn?</h2>
                <p data-id="element-1151">Orgz ehf., kt. 630122-1650, Reykjavík, er ábyrgðaraðili að vinnslu persónuupplýsinga á þessum vef. Fyrirspurnir um persónuvernd má senda á helgi@orgz.is.</p>
              </section>

              <section data-id="element-1152">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1153">Hvaða upplýsingar eru teknar saman?</h2>
                <p data-id="element-1154">Við tökum saman upplýsingar sem þú gefur af þér sjálfviljugur, til dæmis þegar þú hefur samband í gegnum samskiptaeyðublað eða tölvupóst. Þetta getur falið í sér nafn, netfang og skilaboð.</p>
                <p className="mt-3" data-id="element-1155">Vefurinn notar engar vafrakökur til rekja hegðun notenda og við sefjum engar persónugreinanlegar upplýsingar til þriðja aðila í markaðssetningarskyni.</p>
              </section>

              <section data-id="element-1156">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1157">Til hvers eru upplýsingarnar notaðar?</h2>
                <p data-id="element-1158">Upplýsingar sem þú sendir eru eingöngu notaðar til að svara fyrirspurnum þínum og skipuleggja þjónustu. Við sendum þér ekki tölvupóst án þess að þú hafir beðið um það.</p>
              </section>

              <section data-id="element-1159">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1160">Réttindi þín</h2>
                <p data-id="element-1161">Samkvæmt lögum um persónuvernd og meðferð persónuupplýsinga nr. 90/2018 (og GDPR) átt þú rétt á að:</p>
                <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-1162">
                  <li data-id="element-1163">fá upplýsingar um hvaða gögn við höfum um þig</li>
                  <li data-id="element-1164">fá gögn leiðrétt eða eytt</li>
                  <li data-id="element-1165">gera andmæli við vinnslu gagna</li>
                  <li data-id="element-1166">flytja gögn þín (gagnaflutningstéttur)</li>
                </ul>
                <p className="mt-3" data-id="element-1167">Til að nýta réttindi þín, hafðu samband á helgi@orgz.is. Þú getur einnig kvartað til Persónuverndar (personuvernd.is) ef þú telur réttindi þín hafa verið brotin.</p>
              </section>

              <section data-id="element-1168">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1169">Varðveislutími</h2>
                <p data-id="element-1170">Samskiptaupplýsingar eru varðveittar eins lengi og þörf krefur vegna umsaminnar þjónustu eða þar til þú óskar eftir eyðingu.</p>
              </section>

              <section data-id="element-1171">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1172">Breytingar á stefnu</h2>
                <p data-id="element-1173">Við kunnum að uppfæra þessa stefnu. Breytingar taka gildi við birtingu á þessum vef.</p>
              </section>
            </> : <>
              <section data-id="element-1174">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1175">Who is responsible?</h2>
                <p data-id="element-1176">Orgz ehf., registration no. 630122-1650, Reykjavík, Iceland, is the data controller for personal information processed through this website. Questions about privacy can be sent to helgi@orgz.is.</p>
              </section>

              <section data-id="element-1177">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1178">What information is collected?</h2>
                <p data-id="element-1179">We only collect information you provide voluntarily, for example when you contact us through the contact form or by email. This may include your name, email address, and message content.</p>
                <p className="mt-3" data-id="element-1180">This website does not use tracking cookies and we do not share personally identifiable information with third parties for marketing purposes.</p>
              </section>

              <section data-id="element-1181">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1182">How is the information used?</h2>
                <p data-id="element-1183">Information you submit is used solely to respond to your enquiries and arrange services. We do not send you email unless you have requested it.</p>
              </section>

              <section data-id="element-1184">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1185">Your rights</h2>
                <p data-id="element-1186">Under Icelandic Act on Data Protection no. 90/2018 (implementing GDPR), you have the right to:</p>
                <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-1187">
                  <li data-id="element-1188">request information about what data we hold about you</li>
                  <li data-id="element-1189">have data corrected or deleted</li>
                  <li data-id="element-1190">object to processing</li>
                  <li data-id="element-1191">data portability</li>
                </ul>
                <p className="mt-3" data-id="element-1192">To exercise your rights, contact helgi@orgz.is. You may also lodge a complaint with the Icelandic Data Protection Authority (personuvernd.is).</p>
              </section>

              <section data-id="element-1193">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1194">Retention</h2>
                <p data-id="element-1195">Contact information is retained for as long as required for agreed services, or until you request deletion.</p>
              </section>

              <section data-id="element-1196">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1197">Changes to this policy</h2>
                <p data-id="element-1198">We may update this policy from time to time. Changes take effect upon publication on this website.</p>
              </section>
            </>}
        </div>
      </div>
    </div>;
}